const contacto = () => {
	document.addEventListener("DOMContentLoaded", function () {
		// Get utm params
		function getUTMParams() {
			const urlSearchParams = new URLSearchParams(window.location.search);
			const utmParams = {};

			const utmKeys = [
				"utm_source",
				"utm_medium",
				"utm_campaign",
				"utm_term",
				"utm_content",
			];

			utmKeys.forEach((key) => {
				if (urlSearchParams.has(key)) {
					utmParams[key] = urlSearchParams.get(key);
				}
			});

			return utmParams;
		}

		const utmParams = getUTMParams();
		// console.log(utm);

		const formularios = document.querySelectorAll(".forma-contacto");
		const formasArray = Array.from(formularios);

		// Si existe el formulario
		if (formasArray.length > 0) {
			formasArray.forEach((forma) => {
				const nombre = forma.querySelector("#nombre");
				const apellidos = forma.querySelector("#apellidos");
				const email = forma.querySelector("#email");
				const tel = forma.querySelector("#tel");
				const submit = forma.querySelector("#submit");
				const aviso = forma.querySelector(".aviso-check");
				const url = forma.querySelector("#url");
				const utm = forma.querySelector("#utm");

				url.value = window.location.href;
				utm.value = JSON.stringify(utmParams);

				aviso.addEventListener("change", function () {
					if (aviso.checked) {
						submit.disabled = false;
					} else {
						submit.disabled = true;
					}
				});

				forma.addEventListener("submit", function (e) {
					if (
						nombre.value === "" ||
						nombre.value === null ||
						nombre.value === false ||
						nombre.value === undefined
					) {
						nombre.classList.add("is-invalid");
						e.preventDefault();
					} else {
						nombre.classList.remove("is-invalid");
					}

					if (
						apellidos.value === "" ||
						apellidos.value === null ||
						apellidos.value === false ||
						apellidos.value === undefined
					) {
						apellidos.classList.add("is-invalid");
						e.preventDefault();
					} else {
						apellidos.classList.remove("is-invalid");
					}

					if (
						tel.value === "" ||
						tel.value === null ||
						tel.value === false ||
						tel.value === undefined
					) {
						tel.classList.add("is-invalid");
						e.preventDefault();
					} else {
						tel.classList.remove("is-invalid");
					}

					if (
						email.value === "" ||
						email.value === null ||
						email.value === false ||
						email.value === undefined
					) {
						email.classList.add("is-invalid");
						e.preventDefault();
					} else {
						email.classList.remove("is-invalid");
					}
				});
			});
		}
	});
};

export default contacto;
